//types
import { Team } from "../types/types";

export const teamsAC: Team = {
  ALI: {
    id: "ALI",
    name: "Alianza Lima",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  BIA: {
    id: "BIA",
    name: "Biavo FC",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  UNI: {
    id: "UNI",
    name: "Universitario",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  UCV: {
    id: "UCV",
    name: "César Vallejo",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  CRI: {
    id: "CRI",
    name: "Sporting Cristal",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  DIL: {
    id: "DIL",
    name: "Defensores de Ilucán",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  FLA: {
    id: "FLA",
    name: "Flamengo",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  MEL: {
    id: "MEL",
    name: "Melgar",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  KIL: {
    id: "KIL",
    name: "Killas FC",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  MAN: {
    id: "MAN",
    name: "Mannucci",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  REA: {
    id: "REA",
    name: "Real Ancash",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
  UNS: {
    id: "UNS",
    name: "UNSAAC",
    seasons: [
      {
        name: "apertura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "clausura",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
      {
        name: "acumulado",
        points: 0,
        playedMatches: 0,
        wonMatches: 0,
        drawnMatches: 0,
        lostMatches: 0,
        goalsFor: 0,
        goalsAgainst: 0,
        goalsDifference: 0,
      },
    ],
  },
};

export const registeredTeams = Array.from(new Set(Object.keys(teamsAC)));
